import { useState, useEffect, Fragment, useMemo } from "react";
import { selectCurrentUser, selectUsers } from 'src/modules/users/selector';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { selectItems } from "src/modules/spItems/selectors";
import { Comment } from "src/components/ui-icons/card";
import { addUsers } from "src/modules/users/actions";
import _ from 'lodash';
import HistoryStatuses from "../historyStatuses";
import HistoryFieldChanges from "../historyFieldChanges";
import { ArrowDown, ArrowUp } from "src/components/ui-icons/card";
import { TooltipItem } from "src/utils/Tooltip";
import { UserAvatar } from "src/components/ui/avatar/Avatar";
import { historyChangeFieldsDocumentListName } from "src/api/config";
import { getItemsRequest } from "src/modules/spItems/api";
import moment from "moment";
import { FlexCol } from "src/utils/flexLayouts";
import Loading from "src/components/Loading";

const HistoryCard = ({ versionView, documentCardID }: any) => {

    const [historyCard, setHistoryCard] = useState<any>([]);
    const users: any = useAppSelector(selectUsers);
    const dispatch = useAppDispatch();
    const [approvers, setApprovers] = useState<any>({});
    const [customLoading, setCustomLoading] = useState(true);

    useEffect(() => {
        getItemsRequest({ listName: historyChangeFieldsDocumentListName, filters: { DocumentID: versionView || documentCardID, VersionDocument: versionView && true || false }, sortOrder: { name: 'ID', asc: true } }).then((results) => {
            if (results.items.length > 0) {
                let usersEmail: any = [];
                // @ts-ignore
                results.items.forEach((item: any) => {
                    Object.keys(item).forEach((key) => {
                        const field = item[key];
                        if (field && !Array.isArray(field) && field.get_email) {
                            if (field.get_email()) {
                                usersEmail = [...usersEmail, field.get_email().toLowerCase()];
                            }
                        }
                        if (
                            field &&
                            Array.isArray(field) &&
                            field.length > 0 &&
                            field[0].get_email
                        ) {
                            field.forEach((user) => {
                                if (user.get_email()) {
                                    usersEmail = [
                                        ...usersEmail,
                                        user.get_email().toLowerCase(),
                                    ];
                                }
                            });
                        }
                    });
                });
                usersEmail = _.uniqWith(usersEmail, _.isEqual);
                if (usersEmail.length > 0) {
                    let actualEmails: any = [];
                    usersEmail.forEach((item: string) => {
                        let check = false;
                        Object.keys(users).forEach((key) => {
                            if (key === item) {
                                check = true;
                            }
                        });
                        if (!check) {
                            actualEmails = [...actualEmails, item.toLowerCase()];
                        }
                    });
                    if (actualEmails) {
                        dispatch(addUsers(actualEmails));
                    }
                }
            }
            setHistoryCard([...results.items]);
            setCustomLoading(false);
        });
    }, []);

    useEffect(() => {
        console.log(" <===> historyCard: ", historyCard);
        if (historyCard.length > 0) {
            historyCard.forEach((history: any) => {
                let tempApprovers = `<div class="flex flex-col gap-2">`;
                if (history.Approvers && history.Approvers.length > 0) {
                    let userHistory;
                    if (history.ImportAuthor) {
                        userHistory = history.ImportAuthor.get_email();
                    } else {
                        userHistory = history.Author.get_email();
                    }
                    history.Approvers.forEach((approver: any) => {
                        tempApprovers += `<div class="flex items-center gap-2 relative">
                        ${users[approver.get_email()] && users[approver.get_email()].avatar && `<img class="w-6 h-6 rounded-full max-sm:h-6 max-sm:w-6" src="${users[approver.get_email()].avatar}" />` || `<div class="flex items-center justify-center w-6 h-6 rounded-full max-sm:h-6 max-sm:w-6 bg-darkblue">
                                <span class="font-medium text-[12px] max-sm:text-[10px] text-white select-none">${users[approver.get_email()] && users[approver.get_email()].displayName && users[approver.get_email()].displayName.split(' ')[0][0] + users[approver.get_email()].displayName.split(' ')[1][0]}</span>
                            </div>`}
                    <div class="flex flex-col justify-center items-start">
                        <span class="text-sm text-[#111928]">${users[approver.get_email()] && users[approver.get_email()].displayName}</span>
                    </div>
                    ${userHistory.toLowerCase() !== approver.get_email() && `<div class="bg-white/[.75] absolute w-full h-full"></div>` || ''}
                </div>`
                    });
                    tempApprovers += `</div>`;
                    setApprovers((prevState: any) => {
                        return {
                            ...prevState,
                            ...{ [history.ID]: tempApprovers }
                        }
                    });
                }
            });
        }
    }, [historyCard, users]);

    return (
        <>
            {customLoading &&
                <FlexCol className="items-center justify-center w-full">
                    <span className="block mb-5 text-base text-darkblue">
                        Идет обработка данных.
                        <br />
                        Пожалуйста подождите...
                    </span>
                    <Loading />
                </FlexCol>
                ||
                <div className="flex-1 bg-white rounded-lg shadow-xl">
                    <div className="relative px-4">
                        {historyCard.length > 1 &&
                            <div className="absolute left-[14.5px] h-full border border-solid border-[#DFE4EA]"></div>
                        }
                        {historyCard.length > 0 && historyCard.map((history: any) => (
                            <div className="history_block flex w-full my-6 -ml-1.5">
                                <div className="pt-5 flex items-start w-2/12 z-10">
                                    <div className="w-2.5 h-2.5 bg-[#DFE4EA] rounded-full mr-4 mt-1.5"></div>
                                    <span className="text-[#637381] text-sm">{moment(history.Created).format('HH:mm DD.MM.YYYY')}</span>
                                </div>
                                <div className="flex p-5 flex-col justify-center items-start gap-5 flex-[1_0%_0%] w-9/12 rounded-lg border border-solid border-[#DFE4EA]">
                                    <div className="w-full items-center flex justify-between">
                                        <div className="flex items-center gap-2">
                                            {!history.MultiApprove && (
                                                <>
                                                    {history.ImportAuthor &&
                                                        <UserAvatar
                                                            avatar={users[history.ImportAuthor.get_email()] && users[history.ImportAuthor.get_email()].avatar}
                                                            shortName={users[history.ImportAuthor.get_email()] && users[history.ImportAuthor.get_email()].displayName && users[history.ImportAuthor.get_email()].displayName.split(' ')[0][0] + users[history.ImportAuthor.get_email()].displayName.split(' ')[1][0]}
                                                            displayName={users[history.ImportAuthor.get_email()] && users[history.ImportAuthor.get_email()].displayName}
                                                            email={history.ImportAuthor.get_email()}
                                                        /> || <UserAvatar
                                                            avatar={users[history.Author.get_email()] && users[history.Author.get_email()].avatar}
                                                            shortName={users[history.Author.get_email()] && users[history.Author.get_email()].displayName && users[history.Author.get_email()].displayName.split(' ')[0][0] + users[history.Author.get_email()].displayName.split(' ')[1][0]}
                                                            displayName={users[history.Author.get_email()] && users[history.Author.get_email()].displayName}
                                                            email={history.Author.get_email()}
                                                        />
                                                    }
                                                    {history.ImportAuthor &&
                                                        <div className="flex flex-col justify-center items-start">
                                                            <span className="text-sm text-[#111928]">{users[history.ImportAuthor.get_email()] && users[history.ImportAuthor.get_email()].displayName}</span>
                                                            <span className="text-sm text-[#637381]" dangerouslySetInnerHTML={{ __html: users[history.ImportAuthor.get_email()] && users[history.ImportAuthor.get_email()]['jobTitle'] }} />
                                                        </div> ||
                                                        <div className="flex flex-col justify-center items-start">
                                                            <span className="text-sm text-[#111928]">{users[history.Author.get_email()] && users[history.Author.get_email()].displayName}</span>
                                                            <span className="text-sm text-[#637381]" dangerouslySetInnerHTML={{ __html: users[history.Author.get_email()] && users[history.Author.get_email()]['jobTitle'] }} />
                                                        </div>
                                                    }
                                                    {!history.ChangeRights && history.Approvers && history.Approvers.length > 1 &&
                                                        <TooltipItem position="top-left" className="w-max" tooltipsComponent={approvers[history.ID]} tooltipsText="">
                                                            <div className="flex items-center flex-col">
                                                                <ArrowDown />
                                                            </div>
                                                        </TooltipItem>
                                                    }
                                                    {history.ChangeRights && history.Approvers && history.Approvers.length &&
                                                        <TooltipItem position="top-left" className="w-max" tooltipsReactNode={
                                                            <div className="flex flex-col gap-2">
                                                                {[...[history.ChangeRights], ...history.Approvers].map((approver: any) => (
                                                                    <div className="flex items-center gap-2 relative">
                                                                        {users[approver.get_email()] && users[approver.get_email()].avatar && <img className="w-6 h-6 rounded-full max-sm:h-6 max-sm:w-6" src={users[approver.get_email()].avatar} /> || <div className="flex items-center justify-center w-6 h-6 rounded-full max-sm:h-6 max-sm:w-6 bg-darkblue">
                                                                            <span className="font-medium text-[12px] max-sm:text-[10px] text-white select-none">{users[approver.get_email()] && users[approver.get_email()].shortName}</span>
                                                                        </div>}
                                                                        <div className="flex flex-col justify-center items-start">
                                                                            <span className="text-sm text-[#111928]">{users[approver.get_email()] && users[approver.get_email()].displayName}</span>
                                                                        </div>
                                                                        {history.Approvers.some((prevApprover: any) => prevApprover.get_email() === approver.get_email()) && <div className="bg-white/[.75] absolute w-full h-full"></div>}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        } tooltipsText="">
                                                            <div className="flex items-center flex-col">
                                                                <ArrowDown />
                                                            </div>
                                                        </TooltipItem>
                                                    }
                                                </>
                                            )}
                                            {history.MultiApprove && (
                                              <></>
                                            )}
                                        </div>
                                        <HistoryStatuses statuses={history.Statuses} />
                                    </div>
                                    {history.Comment &&
                                        <div className="flex items-center gap-2">
                                            <Comment />
                                            <span className="text-sm text-[#111928]">{history.Comment}</span>
                                        </div>
                                    }
                                    <HistoryFieldChanges documentCardID={documentCardID} versionView={versionView} JsomHistoryFields={history.JSONChangesFields} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            }
        </>
    );
};

export default HistoryCard;
